import axios from "./axios-auth";

const fetchFaxDataByOrderId = (payload) =>
    new Promise((resolve, reject) => {
        axios({
            url: "/dv-adm/getfaxorders",
            params: payload,
            method: "GET",
        })
            .then((resp) => {
                resolve(resp.data);
            })
            .catch(() => {
                console.log("error from fetchFaxDataByOrderId api");
            });
    });

const sendOrdersViaEmailApi = (payload) =>
    new Promise((resolve, reject) => {
        axios({
            url: "/dv-adm/sendorderemail",
            data: payload,
            method: "POST",
        })
            .then((resp) => {
                resolve(resp);
            })
            .catch(() => {
                console.log("error from sendOrdersViaEmailApi api");
            });
    })

export {
    fetchFaxDataByOrderId, sendOrdersViaEmailApi
};
